export default {
  title: 'Não perca!',
  description: 'Ative as notificações para acompanhar a sua encomenda.',
  buttons: {
    enable: 'Ativar',
  },
};
